<!--
 * @Author: wang peng
 * @Description: 历史订单列表  
-->
<template>
  <scroll-layout class="directConnectionPile-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button v-rbac="'order:charge:his:column'" type="plain" @click="customColumns">
              自定义列
            </ykc-button>
            <ykc-button v-rbac="'order:charge:his:export'" type="plain" @click="doExportFile">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
      <!--自定义列弹窗 -->
      <ykc-operation-dialog
        title="自定义列"
        show-footer
        :show.sync="showDialog"
        :before-close="onCLose"
        :before-cancel="onCLose"
        :before-confirm="beforeConfirm">
        <div slot="content">
          <el-form
            size="mini"
            label-width="80px"
            ref="customForm"
            class="customForm"
            :model="customForm"
            :rules="customRules">
            <el-form-item label="列选项:" prop="checkOption">
              <ykc-checkbox
                :configSet="{
                  label: 'label',
                  value: 'value',
                }"
                :data="customData"
                v-model="customForm.checkOption"
                @change="checkboxChange"></ykc-checkbox>
            </el-form-item>
          </el-form>
        </div>
      </ykc-operation-dialog>
    </div>
  </scroll-layout>
</template>
<script>
  import { code, getLastTime, localSetItem, localGetItem, offlineExport } from '@/utils';
  import { orderPage } from '@/service/apis';

  export default {
    name: 'historicalOrderList',
    components: {},
    inject: ['reload'],
    data() {
      return {
        showDialog: false,
        searchParams: {
          date: [],
          startChargingTimeStart: '',
          startChargingTimeEnd: '',
          userAccount: '',
          plateNumber: '',
          stationName: '',
          orgName: '',
          tradeSeq: '',
          cardNo: '',
          tradeStatus: '',
          discountNo: '',
          zdlTradeSeq: '',
          recordIds: [],
          chargingSource: '',
        },
        customForm: {
          checkOption: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        },
        customData: [
          {
            value: 0,
            label: '充电单号',
          },
          {
            value: 1,
            label: '充电用户',
          },
          {
            value: 2,
            label: '归属机构',
          },
          {
            value: 3,
            label: '车牌号码',
          },
          {
            value: 4,
            label: '结算时间',
          },
          {
            value: 5,
            label: '充电站',
          },
          {
            value: 6,
            label: '电量（度）',
          },
          {
            value: 7,
            label: '起始SOC',
          },
          {
            value: 8,
            label: '商户',
          },
          {
            value: 9,
            label: '充电卡号',
          },
          {
            value: 10,
            label: '电桩品牌',
          },
          {
            value: 11,
            label: '电桩型号',
          },
          {
            value: 12,
            label: '电桩功率',
          },
          {
            value: 13,
            label: '电桩类型',
          },
          {
            value: 14,
            label: '启动来源',
          },
          {
            value: 15,
            label: '车辆VIN',
          },
          {
            value: 16,
            label: '流量互联单号',
          },
          {
            value: 17,
            label: '桩联互联单号',
          },
          {
            value: 18,
            label: '订单金额',
          },
          {
            value: 19,
            label: '应收',
          },
          {
            value: 20,
            label: '实付',
          },
          {
            value: 21,
            label: '启动时长',
          },
          {
            value: 22,
            label: '订单电费',
          },
          {
            value: 23,
            label: '订单服务费',
          },
          {
            value: 24,
            label: '平台电费折扣',
          },
          {
            value: 25,
            label: '平台服务费折扣',
          },
          {
            value: 26,
            label: '电费卡券抵扣',
          },
          {
            value: 27,
            label: '服务费卡券抵扣',
          },
          {
            value: 28,
            label: '支付钱包',
          },
          {
            value: 29,
            label: '商户电费折扣',
          },
          {
            value: 30,
            label: '商户服务费折扣',
          },
          {
            value: 31,
            label: '支付状态',
          },
        ],
        customRules: {
          checkOption: [{ required: true, message: '请至少选择一个列名称', trigger: 'blur' }],
        },
        tableTitle: '订单列表',
        tableData: [],
        tableOperateButtons: [], // 列表操作
        tableColumns: [
          { label: '充电单号', prop: 'tradeSeq', minWidth: '200px', id: 0 },
          {
            label: '充电用户',
            prop: 'nickName',
            minWidth: '250px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <span>
                    {row.userAccount}({row.nickName})
                  </span>
                );
              },
            },
            id: 1,
          },
          { label: '归属机构', prop: 'companyName', minWidth: '150px', id: 2 },
          { label: '车牌号码', prop: 'plateNumber', minWidth: '150px', id: 3 },
          { label: '结算时间', prop: 'tradeTime', minWidth: '180px', id: 4 },
          { label: '充电站', prop: 'stationName', minWidth: '150px', id: 5 },
          { label: '电量(度)', prop: 'chargedPower', minWidth: '150px', id: 6 },
          { label: '起始SOC(%)', prop: 'startSoc', minWidth: '150px', id: 7 },

          { label: '商户', prop: 'stationOperatorName', minWidth: '150px', id: 8 },
          { label: '充电卡号', prop: 'cardNo', minWidth: '150px', id: 9 },
          { label: '电桩品牌', prop: 'name', minWidth: '150px', id: 10 },
          { label: '电桩型号', prop: 'modelName', minWidth: '150px', id: 11 },
          { label: '电桩功率(KW)', prop: 'pilePower', minWidth: '150px', id: 12 },
          {
            label: '电桩类型',
            prop: 'pileType',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.pileType === 1 ? '直流' : '交流'}</span>;
              },
            },
            id: 13,
          },
          {
            label: '启动来源',
            prop: 'chargingSource',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                const cls = [
                  { id: 1, name: '扫码启动' },
                  { id: 2, name: '扫码启动' },
                  { id: 3, name: '刷卡充电' },
                  { id: 4, name: '即插即充' },
                  { id: 5, name: '流量方' },
                ][Number(row.chargingSource) - 1];

                if (!cls) {
                  return '一';
                }

                return <span>{cls.name}</span>;
              },
            },
            id: 14,
          },
          { label: '车辆VIN', prop: 'carVinCode', minWidth: '150px', id: 15 },
          { label: '流量互联单号', prop: 'zdlTradeSeq', minWidth: '150px', id: 16 },
          { label: '桩联互联单号', prop: 'pileTradeSeq', minWidth: '150px', id: 17 },
          {
            label: '订单金额(元)',
            prop: 'totalAmount',
            minWidth: '150px',
            id: 18,
          },
          {
            label: '应收(元)',
            prop: 'operatorActualIncome',
            minWidth: '150px',
            id: 19,
          },
          {
            label: '实付(元)',
            prop: 'userActualIncome',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                const startStatus = row.tradeStatus === '11' ? 'status-red' : '';
                return (
                  <span class={[startStatus]}>
                    {row.tradeStatus === '11' ? '未支付' : `${row.userActualIncome}`}
                  </span>
                );
              },
            },
            id: 20,
          },
          { label: '启动时长(S)', prop: 'startChargedTime', minWidth: '150px', id: 21 },
          {
            label: '订单电费(元)',
            prop: 'chargedAmount',
            minWidth: '150px',
            id: 22,
          },
          {
            label: '订单服务费(元)',
            prop: 'parkedAmount',
            minWidth: '150px',
            id: 23,
          },
          {
            label: '平台电费折扣(元)',
            prop: 'platformActivityAndMemberChargedAmount',
            minWidth: '150px',
            id: 24,
          },
          {
            label: '平台服务费折扣(元)',
            prop: 'platformActivityAndMemberServiceDiscountAmount',
            minWidth: '150px',
            id: 25,
          },
          {
            label: '电费卡券抵扣(元)',
            prop: 'creditCardChargedDiscountAmount',
            minWidth: '150px',
            id: 26,
          },
          {
            label: '服务费卡券抵扣(元)',
            prop: 'creditCardServiceDiscountAmount',
            minWidth: '150px',
            id: 27,
          },
          {
            label: '支付钱包',
            prop: 'payType',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                const cls = localGetItem('dictionary')?.pay_type[row.payType] || '';

                if (!cls) {
                  return '一';
                }

                return <span>{cls.name}</span>;
              },
            },
            id: 28,
          },
          {
            label: '商户电费折扣(元)',
            prop: 'businessActivityChargedDiscountAmount',
            minWidth: '150px',
            id: 29,
          },
          {
            label: '商户服务费折扣(元)',
            prop: 'businessActivityServiceDiscountAmount',
            minWidth: '150px',
            id: 30,
          },
          {
            label: '支付状态',
            prop: 'tradeStatus',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                const startStatus = row.tradeStatus === '11' ? 'status-red' : '';
                return (
                  <span class={[startStatus]}>
                    {row.tradeStatus === '11' ? '待支付' : `已支付`}
                  </span>
                );
              },
            },
            id: 31,
          },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
      };
    },
    created() {
      // 页面跳转传参
      if (this.$route.query.data) {
        const query = JSON.parse(this.$route.query.data);
        console.log('query+++', query);
        if (query.userCardCouponId && query.userCardCouponId !== null) {
          this.searchParams.discountNo = query.userCardCouponId;
        }

        if (query.recordIds && query.recordIds !== null) {
          this.searchParams.recordIds = query.recordIds;
        }
      }

      // 近30天初始化时间
      if (this.searchParams.recordIds !== null) {
        this.searchParams.date = [];
        this.searchParams.startChargingTimeStart = '';
        this.searchParams.startChargingTimeEnd = '';
      } else {
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);
        this.searchParams.date = [startDate, endDate];
        this.searchParams.startChargingTimeStart = startDate;
        this.searchParams.startChargingTimeEnd = endDate;
      }

      // 自定义列处理
      const customForm = localGetItem('historicalOrderCustomForm');

      if (customForm) {
        this.customForm.checkOption = customForm;
        this.tableColumns = this.tableColumns.filter(item => {
          return customForm.includes(item.id);
        });
      } else {
        this.tableColumns = this.tableColumns.filter(item => {
          return ![
            9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
            31,
          ].includes(item.id);
        });
      }

      this.requestList();
      this.initData();
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '开始充电 ',
            placeholder: '请选择充电时间',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '用户账号',
            placeholder: '请输入用户账号',
          },
          {
            comName: 'YkcInput',
            key: 'plateNumber',
            label: '车牌号码',
            placeholder: '请输入车牌号码',
          },
          {
            comName: 'YkcInput',
            key: 'zdlTradeSeq',
            label: '互联单号',
            placeholder: '请输入互联单号',
          },
          {
            comName: 'YkcInput',
            key: 'tradeSeq',
            label: '充电单号',
            placeholder: '请输入充电单号',
          },
          {
            comName: 'YkcInput',
            key: 'cardNo',
            label: '充电卡号',
            placeholder: '请输入充电卡号',
          },
          {
            comName: 'YkcInput',
            key: 'orgName',
            label: '归属机构',
            placeholder: '请输入归属机构',
          },
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '充电站',
            placeholder: '请输入充电站',
          },
          {
            comName: 'YkcInput',
            key: 'discountNo',
            label: '卡券编码',
            placeholder: '请输入卡券编码',
          },
          {
            clearable: true,
            comName: 'YkcDropdown',
            key: 'tradeStatus',
            label: '支付状态',
            placeholder: '请选择支付状态',
            data: [
              { id: '10', name: '已支付' },
              { id: '11', name: '待支付' },
            ],
          },
          {
            clearable: true,
            comName: 'YkcDropdown',
            key: 'chargingSource',
            label: '启动来源',
            placeholder: '请选择启动来源',
            data: [
              { id: '1', name: '扫码启动' },
              { id: '3', name: '刷卡充电' },
              { id: '4', name: '即插即充' },
              { id: '5', name: '流量方' },
            ],
          },
        ];
      },
    },
    methods: {
      /**
       * 初始数据
       */
      initData() {
        this.tableOperateButtons = [
          {
            id: '2',
            enabled: () => code('order:charge:his:detail'),
            text: '详情',
            handleClick: (btn, { row }) => {
              this.$router.push({
                path: '/orderManagement/historicalOrder/Detail',
                query: { recordId: row.recordId },
              });
            },
          },
        ];
      },
      /**
       * 导出
       */
      doExportFile() {
        offlineExport({
          downloadType: 'history_order',
          jsonNode: {
            ...this.searchParams,
          },
        });
      },
      /**
       * 自定义列
       * */
      customColumns() {
        this.showDialog = true;
      },
      /**
       * 组件change方法调用信息提示
       */
      checkboxChange(e) {
        this.customForm.checkOption = e;
        console.log('this.customForm+++', this.customForm);
      },
      /**
       *  弹窗确认
       * */
      beforeConfirm(done) {
        console.log('确认', this.customForm);
        this.$refs.customForm.validate(valid => {
          if (valid) {
            localSetItem('historicalOrderCustomForm', JSON.stringify(this.customForm.checkOption));
            done();
            this.reload();
          }
        });
      },
      /**
       * 弹窗关闭
       * */
      onCLose() {
        this.showDialog = false;
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        console.log('searchData++++', searchData);
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, searchData);

        if (searchData.date && searchData.date.length > 0) {
          [this.searchParams.startChargingTimeStart, this.searchParams.startChargingTimeEnd] =
            searchData.date;
        }

        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        console.log('清空查询', form);
        Object.assign(this.searchParams, form);

        // 近30天初始化时间
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);

        this.searchParams.date = [startDate, endDate];
        this.searchParams.startChargingTimeStart = startDate;
        this.searchParams.startChargingTimeEnd = endDate;
      },
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        orderPage
          .historyChargingOrderPage(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-checkbox .icon-check {
    top: 7px;
  }

  .directConnectionPile-list {
    .ykc-table {
      .el-table .el-table__row {
        .cell .userStatus {
          padding-left: 8px;
          position: relative;
        }
        .cell .userStatus::after {
          display: block;
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 100%;
          background: #d0021b;
          position: absolute;
          top: 5.5px;
          left: 0;
        }
        .cell .status-red {
          color: #d0021b;
        }

        .cell .status-blue::after {
          background: #4d8cfd;
        }

        .cell .status-green::after {
          background: #02c498;
        }

        .cell .status-black::after {
          background: #9b9b9b;
        }
      }

      .sealBtn {
        color: #4d8cfd;
        cursor: pointer;
      }
    }
  }

  ::v-deep.ykc-checkbox .icon-check {
    top: 8px;
  }

  ::v-deep.customForm .el-form-item,
  ::v-deep.customForm .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
</style>
